import { RedoButton } from "@redotech/arbiter/buttons/redo-button";
import { Card } from "@redotech/arbiter/card";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { toast } from "@redotech/redo-web/alert";
import { MultiSelectDropdown } from "@redotech/redo-web/select-dropdown";
import { memo, useContext, useState } from "react";
import { RedoAdminClientContext } from "../../../client/context";
import { getSystemViews } from "../../../client/team";
import { TeamContext } from "../../team";
import { setupViews } from "./support-onboarding-actions";

export const SupportOnboarding = memo(function SupportOnboarding() {
  const team = useContext(TeamContext);
  const client = useRequiredContext(RedoAdminClientContext);

  const systemViews = useLoad(async () => {
    const result = await getSystemViews(client);
    return result;
  }, [client]);

  const [viewsToCreate, setViewsToCreate] = useState<readonly string[]>([]);

  async function handleSetupViews() {
    if (!team) {
      return;
    }
    const viewIds = new Set(viewsToCreate);
    const views = (systemViews.value || []).filter((view) =>
      viewIds.has(view._id),
    );
    try {
      await setupViews({ client, teamId: team._id, views });
      toast("Views created successfully", { variant: "success" });
    } catch (e) {
      toast("Error creating views", { variant: "error" });
    }
  }

  return (
    <Card borderRadius="md" title="Support onboarding">
      <Flex dir="column" gap="lg">
        <Text fontSize="sm" fontWeight="medium">
          Views are pulled from the team "[Data] Redo Default Email Templates"
        </Text>

        <Flex dir="row" gap="xl" wrap="wrap">
          <Flex dir="column" gap="md" style={{ minWidth: 250, flex: 1 }}>
            <Text fontSize="md" fontWeight="semibold">
              Views
            </Text>
            <MultiSelectDropdown
              options={(systemViews.value || []).map((view) => view._id)}
              value={viewsToCreate}
              valueChange={(value) => setViewsToCreate(value || [])}
            >
              {(option) => {
                return (
                  <Text fontSize="sm">
                    {
                      (systemViews.value || []).find(
                        (view) => view._id === option,
                      )?.name
                    }
                  </Text>
                );
              }}
            </MultiSelectDropdown>
            <RedoButton
              disabled={viewsToCreate.length === 0}
              hierarchy="primary"
              onClick={handleSetupViews}
              size="sm"
              text="Create these views for this team"
            />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
});
